import Matrix from "../../components/Matrix/Matrix";
import ScrollView from "../../components/ScrollView/ScrollView";
import CardThree from "../../components/cards/CardThree";
import TabsViewFive from "../../components/tabs/TabsViewFive/TabsViewFive";
import materialsPageData from "../../data/english/subpages/materials-page-data";
import Footer from "../../layouts/Footer";
import MainHeader from "../../layouts/MainHeader";
import BorderLeftBox from "../../components/boxes/BorderLeftBox";
import TitleBorderLeft from "../../components/Text/TitleBorderLeft";

const MaterialPage = () => {
  return (
    <main id="main" className="page">
      <div className="sticky-view-two">
        <div className="sticky-container">
          <MainHeader
            title=""
            image={{
              src: require("../../assets/images/backgrounds/background-1.jpg"),
              alt: "Our Materials Matters",
            }}
            imagePosition="left"
          />
        </div>
        <div className="sticky-container-two" id="mainContent">
          <h1 className="title-center">{materialsPageData.mainTitle}</h1>
          <div className="wrapper-small">
            <BorderLeftBox 
              title={materialsPageData.sectionOne.borderLeftBox.title}
              subtitle={materialsPageData.sectionOne.borderLeftBox.subtitle}
            />
            <p className="text-paragraph">{materialsPageData.sectionOne.paragraph}</p>
          </div>
          <div className="wrapper-larg">
          <ScrollView>
            {materialsPageData.sectionOne.cards.map((item, index) => (
              <CardThree
                key={index}
                title={item.title}
                subtitle={item.subtitle}
                icon={{
                  src : require(`../../assets/icons/materials-icons/${item.icon.name}`),
                  alt : item.icon.alt,
                }}
              />
            ))}
          </ScrollView>

          </div>
          <div className="space-50"></div>
          <div className="wrapper-small">
            <TitleBorderLeft>{materialsPageData.sectionTwo.title}</TitleBorderLeft>
            <p className="text-paragraph">{materialsPageData.sectionTwo.sutitle}</p>
            <Matrix data={materialsPageData.sectionTwo.matrixData} />
            <div className="space-50"></div>
            <div className="space-50"></div>
            <TitleBorderLeft>{materialsPageData.sectionTwo.tabsView.title}</TitleBorderLeft>
            <TabsViewFive 
              headers={materialsPageData.sectionTwo.tabsView.tabs.headers}
              tabs={materialsPageData.sectionTwo.tabsView.tabs.elements}
              tableHeaders={materialsPageData.sectionTwo.tabsView.tabs.tableHeaders}
            />
            <div className="space-50"></div>
            <BorderLeftBox 
              title={materialsPageData.sectionTwo.borderLeftBox.title}
              subtitle={materialsPageData.sectionTwo.borderLeftBox.subtitle}
            />
          </div>
          <div className="space-50"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
    </main>
  );
};

export default MaterialPage;
